import { ref } from '@vue/composition-api'
import { Message } from 'element-ui'

export const useOrderDetail = () => {
  // 查看城际订单详情
  const interCityInfo = ref({})
  // const loadingInstance = ref('')
  const viewInterCityInfo = (row) => {
    // loadingInstance.value = Loading.service({ fullscreen: true })
    interCityInfo.value && interCityInfo.value.init && interCityInfo.value.init(row)
  }
  // const closeInterCityLoading = () => {
  //   loadingInstance.value && loadingInstance.value.close && loadingInstance.value.close()
  // }

  // 查看摆渡、接送机订单
  const ferryOrderInfo = ref({})
  const viewFerryOrderInfo = (row) => {
    ferryOrderInfo.value.init && ferryOrderInfo.value.init(row)
  }

  // 查看小件快运订单
  const expressOrderInfo = ref({})
  const viewExpressOrderInfo = (row) => {
    const { id = '' } = row || {}
    expressOrderInfo.value.getDetail && expressOrderInfo.value.getDetail(id)
  }

  // 查看订单详情
  const viewOrderDetail = (row) => {
    const { orderId, orderNo, orderType } = row || {}
    if (!orderType) {
      Message.error('没有业务类型，无法查看订单详情')
      return
    }
    // 1 城际订单   2 摆渡订单、接送机订单  3 小件快运
    if (parseInt(orderType) === 1) {
      if (!orderId) {
        Message.error('没有订单id，无法查看订单详情')
        return
      }
      viewInterCityInfo({ id: row.orderId })
      return
    }
    if (parseInt(orderType) === 2) {
      if (!orderNo) {
        Message.error('没有订单编号，无法查看订单详情')
        return
      }
      viewFerryOrderInfo({ ferryOrderNo: orderNo })
      return
    }
    if (parseInt(orderType) === 3) {
      if (!orderId) {
        Message.error('没有订单id，无法查看订单详情')
        return
      }
      viewExpressOrderInfo({ id: orderId })
    }
  }

  return {
    interCityInfo,
    viewInterCityInfo,
    // closeInterCityLoading,
    ferryOrderInfo,
    viewFerryOrderInfo,
    expressOrderInfo,
    viewExpressOrderInfo,
    viewOrderDetail
  }
}
